// StickyCTA.jsx — mobile-only sticky button with flowing liquid-mercury fill
// (ocean wave moving sideways + a chrome sheen sweep, fully contained inside).
import React, { useEffect, useState } from "react";
import { Icon } from "./Primitives";
import { useIsMobile } from "./hooks";

export default function StickyCTA({ show, onShop }) {
  const isMobile = useIsMobile();
  const [nearBottom, setNearBottom] = useState(false);
  useEffect(() => {
    const f = () => {
      const d = document.documentElement;
      setNearBottom(window.innerHeight + window.scrollY > d.scrollHeight - 280);
    };
    window.addEventListener("scroll", f, { passive: true });
    window.addEventListener("resize", f);
    f();
    return () => { window.removeEventListener("scroll", f); window.removeEventListener("resize", f); };
  }, []);
  if (!isMobile) return null;
  const visible = show && !nearBottom;
  return (
    <div className={`k-sticky-cta${visible ? " show" : ""}`}>
      <button className="k-liquid-btn" data-testid="sticky-shop-cta" onClick={onShop} aria-label="Shop Klaren">
        <span className="k-liquid-waves" aria-hidden="true">
          <span className="k-wave w2" />
          <span className="k-wave w1" />
          <span className="k-sheen" />
        </span>
        <span className="k-liquid-text">Shop Klaren <Icon name="arrow-right" size={17} /></span>
      </button>
    </div>
  );
}
